import React from 'react';
import Seo from '../components/Seo';
import Header from '../components/Header';
import FactoryHero from '../components/FactoryHero';
import ProofStrip from '../components/ProofStrip';
import PipelineSection from '../components/PipelineSection';
import DemoSection from '../components/DemoSection';
import Chapters from '../components/Chapters';
import VerificationSection from '../components/VerificationSection';
import DeploySection from '../components/DeploySection';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

const LandingPage = () => (
  <div className="min-h-screen bg-white dark:bg-black">
    <Seo
      title="Emboscale — The Factory Agent"
      description="The Factory Agent: one prompt becomes a factory, first draft in 30 minutes. AI factory layout planning, shift scheduling, line balancing, digital work instructions, and verified AI robot programming — end to end."
      path="/"
    />
    <Header />
    <FactoryHero />
    <ProofStrip />
    <PipelineSection />
    <DemoSection />
    <Chapters />
    <VerificationSection />
    <DeploySection />
    <FAQSection />
    <CTASection />
    <Footer />
  </div>
);

export default LandingPage;
